import React, { useState, useContext, useEffect } from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import { WeekReflectionContext } from '../WeekReflectionContext';

export const TaglineInput = ({ story, action, isPaused, storyData }) => {
    const [textActivity, setTextActivity] = useState(false);
    const { textInputs, setTextInput, setInputChange, weekReviewManager } = useContext(WeekReflectionContext);
    const [buttonText, setButtonText] = useState('Caption it');

    useEffect(() => {
        if (!textInputs[storyData.component]) {
            setTimeout(() => {
                action('pause');
            }, 5000);
        }
    }, [])

    useEffect(() => {
        if (textActivity) {
            setTimeout(() => {
                action('pause');
            }, 1);
        }
    }, [textActivity])

    const onInput = (e) => {
        const input = e.target.value;
        const wordCount = input.trim()
            .split(/\s+/) // splits string based on whitespace, newline chars
            .filter(Boolean) // removes empty strings
            .length;

        // Only allow update if word count is <= 7 OR if deleting
        if (wordCount <= 7 || input.length < textInputs.weekTitle?.length) {
            setTextInput(prevInput => ({
                ...prevInput,
                [storyData.component]: e.target.value
            }))
        }
        setTextActivity(true);
        setInputChange(true);
    }

    const onClick = async () => {
        weekReviewManager?.saveReflection(textInputs);
        setButtonText('Done!')
        setTimeout(() => {
            action('next');
        }, 5);
    }

    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}
            areCommentsEnabled={false} showPauseButton={true}
        >
            <h1 className={styles.size3} style={{ margin: "1rem", marginBottom: "0.5rem" }}>
                {storyData.data.question}
            </h1>
            <p style={{ fontStyle: "italic", fontSize: "0.8rem", color: "rgba(255, 255, 255, 0.7)" }}>
                In 7 words or less
            </p>
            <div className={styles.reflectionInputDiv}>
                <textarea className={styles.weekTitleInput}
                    spellCheck="false" placeholder={""}
                    onChange={onInput}
                    value={textInputs.weekTitle ?? ''}
                    readOnly={story.view === 'readOnly'}
                />
                {story?.view !== 'readOnly' &&
                    <div style={{ marginTop: "2.5rem", zIndex: 1000 }}>
                        <button className={styles.saveButton}
                            onClick={onClick}
                            style={{ zIndex: 1000 }}
                            disabled={textInputs[storyData.component]?.length === 0 || !textActivity}
                        >
                            {buttonText}
                        </button>
                    </div>
                }
            </div>
        </StoryWrapper>
    );
}